export const TabTitle = (newTitle) => {
  return (document.title = newTitle);
};

export const TabFavIcon = (url) => {
  let favicon = document.getElementById("favicon");
  return (favicon.href = url);
};
